/**
 * Chart.js renders to canvas, which can't resolve Tailwind classes, so callers read the
 * actual token value at paint time (works across the tonal theme) instead of hardcoding hex.
 */
export function cssColor(varName: string, fallback: string): string {
    if (typeof document === "undefined") {
        return fallback;
    }
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    return value || fallback;
}
